import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { getShowPasswordWarning } from 'plugins/mm/rdx';
import { RootDispatch } from 'reducers';

import { checkPasswordExpiration } from './checkPasswordExpiration';

export function usePasswordRotationEarlyWarning() {
  const dispatch: RootDispatch = useDispatch();
  const showPasswordWarning = useSelector(getShowPasswordWarning);

  useEffect(() => {
    if (showPasswordWarning) {
      dispatch(checkPasswordExpiration);
    }
  }, [dispatch, showPasswordWarning]);
}
